import React, { useContext } from 'react'
import { DataContext } from '@visx/xychart'
import { LegendOrdinal } from '@visx/legend'

export default function ChartLegend() {
  const { colorScale, theme } = useContext( DataContext )

  return (
    <LegendOrdinal
      direction="row"
      itemMargin="8px 8px 8px 0"
      scale={colorScale}
      labelFormat={( label ) => {
        return label
      }}
      shape="circle"
      labelAlign="center"
      style={{
        backgroundColor : theme.backgroundColor,
        marginTop : -24,
        display : 'flex', // required in addition to `direction` if overriding styles
        justifyContent : 'center'
      }}/>
  )
}
